import React from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ContactForm from './contact-form';
import '../pages/book-audit.css'; 
import './AuditModal.css';

export default function AuditModal({ show, handleClose }) {
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            centered 
            backdrop="static"
            keyboard={false}
            dialogClassName="audit-modal-dialog-custom"
            className="audit-modal-container"
            contentClassName="audit-popup-card border-0"
            backdropClassName="audit-modal-backdrop"
        >
            <button 
                onClick={handleClose} 
                className="audit-modal-close"
            >&times;</button>

            <Modal.Body className="p-0 w-100">
                <ContactForm onSuccessClose={handleClose} />
            </Modal.Body>
        </Modal>
    );
}
